import { render, staticRenderFns } from "./HistoricalSettlementReport.vue?vue&type=template&id=d81cda80&"
import script from "./HistoricalSettlementReport.vue?vue&type=script&lang=js&"
export * from "./HistoricalSettlementReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports